import { createContext, useContext } from 'react';
import type { Repo } from '../data/repo';
import type { Account, CapitalPosition, Category, Month } from '../data/types';

export interface Base {
  months: Month[];
  categories: Category[];
  accounts: Account[];
  positions: CapitalPosition[];
  openPlan: Month | null;
}

export interface AppCtx {
  repo: Repo;
  base: Base;
  /** Reload months, categories, accounts and positions after a write. */
  refresh: () => Promise<void>;
  /** Sections that failed to load, shown in place rather than blanking the app. */
  baseErrors: string[];
}

export const AppContext = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('AppContext missing');
  return ctx;
}
